import { ContentInfo, ContentBlob } from '@mecontrol/common';

/**
 * Filters out the value of query parameters included in a URL (for privacy purposes) and
 * removes the fragment from a passed in URL
 * @param url The URL to filter
 */
export function scrubUrl(url: string): string {
    if (!url) {
        return url;
    }

    // Filter out the values of the passed in query parameters or all of them
    let filteredUrl = url.replace(/([^?&]*)=([^&#]*)/g, '$1=**');

    // Remove the fragment completely
    let parsedUrl = filteredUrl.replace(/#.*/, '');
    return parsedUrl;
}

/**
 * Creates a string content blob from the content information provided for events
 * @param content Information on the item that was involved in the event
 * @returns String representation of the content blob
 */
export function getContentJson(content: ContentInfo): string {
    let blob: ContentBlob = {
        id: content.id,
        cT: content.type,
        sN: content.slot,
        cS: content.source
    };

    return JSON.stringify(blob, (key: string, value: any) => value == null ? undefined : value);
}
